// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"RolesList_pageHeader__3rVa3"};